module.exports = __webpack_public_path__ + "img/pump-check.6de4470b.svg";